import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SeaModel } from "../../models/sea/sea-model";
import { MinDTO } from 'src/app/models/min-dto';
import { CityService } from 'src/app/services/city/city.service';
import { CountryService } from 'src/app/services/country/country.service';
import { AirModel } from 'src/app/models/air/air-model';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-air-search-filter',
  templateUrl: './air-search-filter.component.html',
  styleUrls: ['./air-search-filter.component.scss']
})

export class AirSearchFilter implements OnInit {

  @Input() model: AirModel = null;
  containerTypes: MinDTO[] = [];
  @Input("airComponent") airComponent: any;
  @Output() reSearch: EventEmitter<AirModel> = new EventEmitter();
  isAdvancedOpen: boolean = true;
  nowDate = new Date();

  constructor(private cityService: CityService, private countryService: CountryService, private translation: TranslateService) { }

  ngOnInit(): void {
    if(this.model.readinessDate && !(this.model.readinessDate instanceof Date)) {
        this.model.readinessDate = new Date(`${String(this.model.readinessDate).substring(0,10).trim()}`);
    }
  }

  _reSearch() {
    this.reSearch.emit(this.model);
  }
  toggleAdvanced(): void {
    this.isAdvancedOpen = !this.isAdvancedOpen;
  }
  isValidForm() {
     return (!this.model.readinessDate || !this.model.departureCountry || !this.model.arrivalCountry || !this.model.departurePort || !this.model.arrivalPort)
  }

    onChangeDepartureCountry() {
      this.model.departurePort = null;
      this.model.departureZip = null;
      this.model.departureCity = null;
    }
    onChangeArrivalCountry() {
      this.model.arrivalPort = null;
      this.model.arrivalZip = null;
      this.model.arrivalCity = null;
    }

    deletePortByField(event: any ,field: string) {
        setTimeout(()=> {
            if (!event?.id){
                this.model[field] = null;
            }
        }, 100);
    }

    async onSelectDepaturePort(data: any) {

        if(data.cityId && data.cityId != 0) {
          const city =   await this.cityService.getById({cityId: data.cityId}).toPromise();
          if(city) this.model.departureCity = city;
        }
         if(data.countryId && data.countryId != 0) {
          const country =   await this.countryService.getById({countryId: data.countryId}).toPromise();
          if(country) this.model.departureCountry = country;
        }
    }

    
    async onSelectArrivalPort(data: any) {

        if(data.cityId && data.cityId != 0) {
          const city =   await this.cityService.getById({cityId: data.cityId}).toPromise();
          if(city) this.model.arrivalCity = city;
        }
         if(data.countryId && data.countryId != 0) {
          const country =   await this.countryService.getById({countryId: data.countryId}).toPromise();
          if(country) this.model.arrivalCountry = country;
        }
    }
    async onBlurTotalVolume() {
      this.airComponent.onBlurTotalVolume();
    }
    calculateTotals(event:any = null) {
      this.airComponent.calculateTotals();
    }
}
